import { render, staticRenderFns } from "./AudioUpload.vue?vue&type=template&id=6ce1f53e&scoped=true&"
import script from "./AudioUpload.vue?vue&type=script&lang=js&"
export * from "./AudioUpload.vue?vue&type=script&lang=js&"
import style0 from "./AudioUpload.vue?vue&type=style&index=0&id=6ce1f53e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce1f53e",
  null
  
)

component.options.__file = "AudioUpload.vue"
export default component.exports